<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
    <path
      d="M297.376 414.4l22.624 22.624 181.024-181.024-45.248-45.248-135.776 135.744-135.776-135.744-45.248 45.248z"
    ></path>
  </svg>
</template>
